// ---------------- Start External Library Import --------------------//
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import PasswordPage from '@techsoftware/happay-widgets/PasswordPage';
import history from '../../utils/history';

export default class passwordPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { loginInfo } = this.props;
    if (!loginInfo.value) {
      history.push('/login');
    }
  }

  onSignIn = value => {
    const { loginInfo } = this.props;
    const pwd = value.password;

    const data = {
      mobile_extension: loginInfo.code,
      user: loginInfo.value,
      password: pwd,
    };
    if (loginInfo.userId) data.user_id = loginInfo.userId;
    this.props.onCallLoginApi(data);
  };

  render() {
    const {
      countryCodes,
      loginInfo,
      productLogo,
      privacyPolicyUrl,
      termOfUseUrl,
    } = this.props;
    return (
      <PasswordPage
        containerClassName="signin-container"
        logo={productLogo}
        // breakPoints={breakPoints}
        onSignIn={this.onSignIn}
        onClickBack={() => {
          history.goBack();
        }}
        onClickOTP={() => history.push('/login/signinwithotp')}
        onClickCantSignin={() => history.push('/login/cantsignin')}
        countryCode={countryCodes}
        data={loginInfo}
        privacyPolicyUrl={privacyPolicyUrl}
        termOfUseUrl={termOfUseUrl}
        privacyPolicyText="Privacy Policy"
        termOfUseText="Terms of Use"
        // signInHeader={i18n.t("logIn.signText")}
        // emailIdFloatingLabelText={i18n.t("logIn.emailId")}
        // emailIdHintText={i18n.t("placeholder.enterEmailID")}
        // codeLabelText={i18n.t("lbl.code")}
        // phoneNoFoatingLabelText={i18n.t("tableHeader.phoneNumber")}
        // phoneNoHintText={i18n.t("placeholder.enterPhoneNumber")}
        // backButtonText={i18n.t("btn.back")}
        // signInButtonText={i18n.t("btn.signIn")}
        // passwordFoatingLabelText={i18n.t("lbl.password")}
        // passwordHintText={i18n.t("placeholder.enterPassword")}
        // passwordSubFooterTextOne={i18n.t("logIn.signInWithOTP")}
        // passwordSubFooterTextTwo={i18n.t("logIn.ifYouHaveForgotten")}
        // passwordSubFooterTextThree={i18n.t("logIn.cantSignIn")}
        // passwordValidStr={i18n.t("err.enterValidPassword")}
        // dialogBoxTitle={i18n.t("logIn.cantSignIn")}
        // dialogBoxContentOne={i18n.t("err.youCanSign")}
        // dialogBoxContentTwo={i18n.t("err.ifYouStill")}
      />
    );
  }
}

passwordPage.propTypes = {
  onCallLoginApi: PropTypes.func,
  productLogo: PropTypes.node,
  privacyPolicyUrl: PropTypes.string,
  termOfUseUrl: PropTypes.string,
  countryCodes: PropTypes.array,
  loginInfo: PropTypes.object,
};

passwordPage.defaultProps = {};
